
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '@/contexts/unified-permissions';
import { toast } from '@/hooks/use-toast';

export const useAdminCheck = () => {
  const navigate = useNavigate();
  const { isAdmin, permissionsStatus } = usePermissions();

  useEffect(() => {
    // Only perform navigation if the admin check is complete
    if (permissionsStatus !== 'loading' && !isAdmin) {
      toast({
        title: 'Access Denied',
        description: 'You do not have permission to access this page',
        variant: 'destructive'
      });
      navigate('/blog');
    }
  }, [isAdmin, permissionsStatus, navigate]);

  return { 
    isAdmin, 
    isLoading: permissionsStatus === 'loading' 
  };
};
